module.exports = __webpack_public_path__ + "img/30-l.e7ff705c.png";